import styled from 'styled-components'
import { useModuleContext } from './contexts/module'
import { Icon } from '@mch-group/uikit-components'

const InfoAboveCard = () => {
  // @ts-ignore
  const { state: { labels, artworkInformation } } = useModuleContext()
  const {
    name: artworkName,
    artists,
    year,
    endYear,
    viewAtFair,
    hybridShow,
    headerTheme,
    textColorClass
  } = artworkInformation || {}
  return (
    <>
      <h2 className={textColorClass}>
        {artists && artists.map(({ artistName }) => artistName).join(', ')}
      </h2>
      <div className={`${textColorClass} h5`}>
        {artworkName}
        {year ? `, ${year}${endYear ? ` - ${endYear}` : ''}` : ''}
      </div>
      {viewAtFair && hybridShow &&
        <ViewOnFair>
          <Icon name='gallery' color={headerTheme === 'LIGHT' ? 'var(--bs-mch-black)' : 'var(--bs-mch-white)'} />
          <p className={`${textColorClass} text-medium`}>{labels?.OnlineShowRoom?.viewAtFairLabel}</p>
        </ViewOnFair>
      }
      {viewAtFair !== undefined && !viewAtFair && hybridShow &&
        <ViewOnFair>
          <p className={`${textColorClass} text-medium`}>{labels?.OnlineShowRoom?.onlineExclusiveLabel}</p>
        </ViewOnFair>
      }
    </>
  )
}

const ViewOnFair = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  align-content: center;

  a {
    display: flex;
    align-items: center;
  }

  svg {
    margin-right: 8px;
    margin-top: -6px;
  }

  p {
    margin-top: 7px;
  }
`

export default InfoAboveCard